import { useEffect, useState } from 'react';
import { useRect } from '@darkroom.engineering/hamo';

export function useAppSizes() {
  const [windowWidth, setWindowWidth] = useState(0);
  const [windowHeight, setWindowHeight] = useState(0);
  const [headerHeight, setHeaderHeight] = useState(0);

  const [setRect] = useRect({
    debounce: 100,
    callback: (rect: DOMRect) => {
      setHeaderHeight(rect.height);
      document.documentElement.style.setProperty(
        '--header-height',
        `${rect.height}px`,
      );
    },
  });

  useEffect(() => {
    if (document === undefined) return;
    const headerElement = document.getElementById('site-header');
    if (headerElement) setRect(headerElement);
  }, [setRect]);

  useEffect(() => {
    if (window === undefined) return;

    let lastWidth = window.innerWidth;
    const coarsePointer = window.matchMedia('(pointer: coarse)');

    const resize = () => {
      const width = window.innerWidth;
      const height = window.innerHeight;
      const widthChanged = width !== lastWidth;
      lastWidth = width;

      setWindowWidth(width);
      // iOS Safari / Slack WebView fire height-only resize when the URL bar
      // shows on scroll-up. Updating sticky math mid-gesture contributes to
      // jumpy scroll on touch devices; keep the last height until width
      // actually changes (real orientation / window resize).
      setWindowHeight((prev) => {
        if (prev === 0) return height;
        if (!widthChanged && coarsePointer.matches) return prev;
        return height;
      });
    };

    resize();
    window.addEventListener('resize', resize);
    return () => window.removeEventListener('resize', resize);
  }, []);

  return { windowWidth, windowHeight, headerHeight };
}
